import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

const StyledContainer = styled.div`
  margin-bottom: 24px;
`;

const StyledRow = styled(Row)`
  margin-bottom: 2rem;
  margin-right: 0;
  margin-left: 0;
  padding: 16px;
  border: 1px solid #ccc;
  ul {
    font-family: RobotoRegular;
    margin-top: 0px;
    list-style: disc;
    font-size: 16px;
    padding-inline-start: 40px;
  }
  li {
    font-size: 16px;
  }
`;

function ProductInfoBlock({header, description}) {
  return (
    <StyledContainer>
      <div className="inputs-block-title">
        <span>{header}</span>
      </div>
      <StyledRow>
        <span>
          {description}
        </span>
      </StyledRow>
    </StyledContainer>
  );
}

export default ProductInfoBlock;
